import { render, staticRenderFns } from "./TablePaginator.vue?vue&type=template&id=8af0462c&scoped=true"
import script from "./TablePaginator.vue?vue&type=script&lang=js"
export * from "./TablePaginator.vue?vue&type=script&lang=js"
import style0 from "./TablePaginator.vue?vue&type=style&index=0&id=8af0462c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af0462c",
  null
  
)

export default component.exports